export default __webpack_public_path__ + "static/media/SVD-10-arrow-go-v2.9f47929b.png";